/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignStatus } from '../../models/campaign-status';
import { CampaignType } from '../../models/campaign-type';
import { GetCampaignsResult } from '../../models/get-campaigns-result';

export interface ApiCampaignsGet$Params {
  CampaignType?: CampaignType;
  Status?: CampaignStatus;
  Cursor?: string;
  Limit?: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiCampaignsGet(http: HttpClient, rootUrl: string, params?: ApiCampaignsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignsResult>> {
  const rb = new RequestBuilder(rootUrl, apiCampaignsGet.PATH, 'get');
  if (params) {
    rb.query('CampaignType', params.CampaignType, {});
    rb.query('Status', params.Status, {});
    rb.query('Cursor', params.Cursor, {});
    rb.query('Limit', params.Limit, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCampaignsResult>;
    })
  );
}

apiCampaignsGet.PATH = '/api/campaigns';
